import { useState } from "react";
import { Grid, Box } from "@mui/material";
import HelpSidebar from "./HelpSidebar";
import ReleaseNote1 from "./release-notes/ReleaseNote1.0";
import ReleaseNote2 from "./release-notes/ReleaseNote2.0";
import ReleaseNote3 from "./release-notes/ReleaseNote3.0";
import ReleaseNote4 from "./release-notes/ReleaseNote4.0";
import ReleaseNote5 from "./release-notes/ReleaseNote5.0";
import ReleaseNote6 from "./release-notes/ReleaseNote6.0";
import ReleaseNote7 from "./release-notes/ReleaseNote7.0";
import ReleaseNote8 from "./release-notes/ReleaseNote8.0";
import ReleaseNote9 from "./release-notes/ReleaseNote9.0";
import ReleaseNote10 from "./release-notes/ReleaseNote10.0";
import ReleaseNote11 from "./release-notes/ReleaseNote11.0";
import ComingSoon from "../../../../components/ComingSoon";

const ReleaseNotes = () => {

  const sidebarItems = [
    { label: "Release 11.0", subMenus: [], subKey: "August 2026" },
    { label: "Release 10.0", subMenus: [], subKey: "July 2026" },
    { label: "Release 9.0", subMenus: [], subKey: "June 2026" },
    { label: "Release 8.0", subMenus: [], subKey: "May 2026" },
    { label: "Release 7.0", subMenus: [], subKey: "March 2026" },
    { label: "Release 6.0", subMenus: [], subKey: "February 2026" },
    { label: "Release 5.0", subMenus: [], subKey: "January 2026" },
    { label: "Release 4.0", subMenus: [], subKey: "November 2025" },
    { label: "Release 3.0", subMenus: [], subKey: "October 2025" },
    { label: "Release 2.0", subMenus: [], subKey: "September 2025" },
    { label: "Release 1.0", subMenus: [], subKey: "July 2025" },
  ];

  const [tab, setTab] = useState(sidebarItems[0].label);

  const renderReleaseNotesDoc = (intent) => {
    switch (intent) {
      case "Release 1.0":
        return <ReleaseNote1 />;
      case "Release 2.0":
        return <ReleaseNote2 />;
      case "Release 3.0":
        return <ReleaseNote3 />;  
      case "Release 4.0":
        return <ReleaseNote4 />;
      case "Release 5.0":
        return <ReleaseNote5 />;
      case "Release 6.0":
        return <ReleaseNote6 />;
      case "Release 7.0":
        return <ReleaseNote7 />;
      case "Release 8.0":
        return <ReleaseNote8 />;
      case "Release 9.0":
        return <ReleaseNote9 />;
      case "Release 10.0":
        return <ReleaseNote10 />;
      case "Release 11.0":
        return <ReleaseNote11 />;
      default:
        return (
            <ComingSoon />
        );
    }
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        bgcolor: "#f5f8fc",
        py: 2,
        height: "calc(100vh - 64px)", // adjust header height if different
        overflow: "hidden",
        minHeight: 0,
      }}
    >
      {/* Sidebar */}
      <Grid item xs={12} md={3} sx={{ height: "100%", minHeight: 0 }}>
        <Box
          sx={{
            bgcolor: "white",
            borderRadius: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            minHeight: 0,
          }}
        >
          <Box
            sx={{
              overflowY: "auto",
              flex: 1,
              minHeight: 0,
              "&::-webkit-scrollbar": { width: "4px" }, // thinner scrollbar
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0,0,0,0.3)",
                borderRadius: "10px",
              },
              scrollbarWidth: "thin",
              scrollbarGutter: "stable",
            }}
          >
            <HelpSidebar sidebarItems={sidebarItems || []} tab={tab} setTab={setTab} />
          </Box>
        </Box>
      </Grid>

      {/* Content */}
      <Grid item xs={12} md={9} sx={{ height: "100%", minHeight: 0 }}>
        <Box
          sx={{
            bgcolor: "white",
            borderRadius: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            minHeight: 0,
          }}
        >
          <Box
            sx={{
              overflowY: "auto",
              flex: 1,
              minHeight: 0,
              p: 4,
              "&::-webkit-scrollbar": { width: "4px" }, // thinner scrollbar
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0,0,0,0.3)",
                borderRadius: "10px",
              },
              scrollbarWidth: "thin",
            }}
          >
            {renderReleaseNotesDoc(tab)}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ReleaseNotes;
